export default __webpack_public_path__ + "static/media/powered-by-stripe.394afab8.svg";